import { render, staticRenderFns } from "./zombie-fan.vue?vue&type=template&id=8097909c&scoped=true&"
import script from "./zombie-fan.vue?vue&type=script&lang=js&"
export * from "./zombie-fan.vue?vue&type=script&lang=js&"
import style0 from "./zombie-fan.vue?vue&type=style&index=0&id=8097909c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8097909c",
  null
  
)

export default component.exports